import React, { useState } from 'react';
import { Modal } from '../../themes/nzf_2022';
import CloseModal from './close-button';


const SessionRow = ({ session, handleSelection, showAsSelectedSession }) => {
  const showAsSelected = showAsSelectedSession && showAsSelectedSession === session.unique_id;

  return (
    <>
      {/* mobile */}
      <li
        onClick={ () => handleSelection(session) }
        className={ `${ showAsSelected ? (session.sold_out ? 'bg-grey-20' : 'bg-black') : 'bg-transparent' } cursor-pointer border2-bottom border2-left border2-right border-light-grey sm+:hidden block px-6 py-4` }
      >
        <div className='flex flex-row flex-ai-center'>
          <span className={ `text-sm sm:text-base font-medium mr-4 ${ showAsSelected ? 'color-white' : 'color-black' }` }>
            { session.start_date_human }
          </span>
          <span className={ `text-sm sm:text-base ${ showAsSelected ? 'color-white' : 'color-black' } lowercase ml-auto` }>
            { session.start_time_human }
          </span>
        </div>

        <div className='flex flex-row flex-ai-center'>
          { session.sold_out && (
            <span className='text-sm color-red line-through mr-4'>Sold out!</span>
          )}
          { (session.is_choose_your_price_session && !session.sold_out) && (
            <span className='mr-4'>
              <span
                className='mr-4 text-sm no-underline cursor-pointer'
              >
                <span className={ `text-sm ${ showAsSelected ? (session.sold_out ? 'color-purple' : 'color-light-purple') : 'color-purple' }` }>Choose your price</span>
              </span>
            </span>
          )}
        </div>
      </li>

      {/* desktop */}
      <li
        role='radio'
        tabIndex='0' // hack to make more like a radio btn
        aria-checked={ `${ showAsSelected ? 'true' : 'false' }` }
        aria-label='Choose your session'
        onClick={ () => handleSelection(session) }
        className={ `${ showAsSelected ? (session.sold_out ? 'bg-grey-20' : 'bg-black') : 'bg-transparent' } cursor-pointer session-list-item flex-row flex-jc-between flex-ai-center py-4 border2-bottom border2-left border2-right border-light-grey mx-auto hidden sm+:flex` }
      >
        <div>
          <span className={ `pl-6 text-xl font-medium mr-4 ${ showAsSelected ? 'color-white' : 'color-black' }` }>
            { session.start_date_human }
          </span>

          { session.is_choose_your_price_session && (
            <span className='mr-4'>
              <span
                className='mr-4 text-sm no-underline cursor-pointer'
              >
                <span className={ `text-sm ${ showAsSelected ? (session.sold_out ? 'color-purple' : 'color-light-purple') : 'color-purple' }` }>Choose your price</span>
              </span>
            </span>
          )}
        </div>
        <div>
          { session.sold_out && (
            <span className='text-sm color-red line-through mr-4'>Sold out!</span>
          )}
          <span className={ `${ showAsSelected ? 'color-white' : 'color-black' } pr-6 lowercase` }>{ session.start_time_human }</span>
        </div>
      </li>
    </>
  );
};

const SessionSelection = ({ sessions, settings, handleSessionSelection }) => {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [selectedSession, setSelectedSession] = useState(null);
  const [showAsSelectedSession, setShowAsSelectedSession] = useState(null);

  const handleSelection = (session) => {
    setButtonDisabled(session.sold_out);
    if (!session.sold_out) {
      setSelectedSession(session);
    } else {
      setSelectedSession(null);
      setShowAsSelectedSession(null);
    }
    setShowAsSelectedSession(session.unique_id);
  };
  return (
    <div className='flex flex-column pt-12 sm+:pt-20'>
      <h3 className='w-8/12 sm+:w-11/12 mx-auto text-center'>Choose your session</h3>

      <ul
        className={ `${ selectedSession ? 'mb-16 sm+:mb-20' : 'mb-48  sm+:mb-56' } mt-16 sm+:mt-20 border2-top px-0 border-light-grey w-11/12 mx-auto` }
        style={{ maxWidth: '600px' }}
        role='radiogroup'
      >
        { sessions.map((session) => (
          <SessionRow
            key={ `${ session.unique_id }` }
            session={ session }
            settings={ settings }
            handleSelection={ handleSelection }
            showAsSelectedSession={ showAsSelectedSession }
          />
        ))}
      </ul>

      <button
        disabled={ buttonDisabled }
        type='button'
        onClick={ () => handleSessionSelection(selectedSession) }
        className={ `${ selectedSession ? 'mb-20' : 'hidden' } btn btn--default btn--large w-11/12 mx-auto px-12 py-4 text-center text-sm sm+:px-3 sm+:max-w-8/12 sm+:mb-20 whitespace-normal` }
      >
        { selectedSession && selectedSession.is_choose_your_price_session ? 'Choose ticket price' : `Buy tickets ${ selectedSession ? `(${ selectedSession.ticket_platform })` : '' }` }
      </button>
    </div>
  );
};

const SessionSelectionModal = ({ sessions, settings, handleSessionSelection }) => {
  return (
    <Modal parsedContent={ (
      <>
        <CloseModal />
        <SessionSelection
          sessions={ sessions }
          settings={ settings }
          handleSessionSelection={ handleSessionSelection }
        />
      </>
    ) }
    />
  );
};

export default SessionSelectionModal;
